import { getAcademicYear } from "./academicYear";

// utils/constants.js
export const STANDARDS = [
  '1st',
  '2nd',
  '3rd',
  '4th',
  '5th',
  '6th',
  '7th',
  '8th',
  '9th',
  '10th',
  '11th',
  '12th',
];

export const SUBJECTS = [
  'Mathematics',
  'Physics',
  'Chemistry',
  'Biology',
  'English',
  'Hindi',
  'Sanskrit',
  'History',
  'Geography',
  'Political Science',
  'Economics',
  'Computer Science',
];

export const ACADEMIC_YEARS = [
  getAcademicYear(),
];

export const SECTIONS = [
  'A',
  'B',
  'C',
  'D',
];
export const ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50];

export const STATUS_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
];

export const VERIFICATION_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'verified', label: 'Verified' },
  { value: 'unverified', label: 'Unverified' },
];